// gkc_hash_code : 01EV64EDXCZTX8ZCEMHJHDQ126
const color = {
  black: '#000',
  black2: '#222',
  black3: 'rgb(34, 34, 34)',
  black4: 'rgb(0, 0, 0)',
  white: '#fff',
  grey: '#f6f8fa',
  grey1: '#e8ebee',
  grey2: '#757b83',
  grey3: '#e0e4e8',
  grey4: '#f9fafb',
  grey5: 'rgba(19, 59, 93, 0.06)',
  grey6: 'rgba(19, 59, 93, 0.12)',
  grey7: '#989ea5',
  grey8: 'rgba(10, 41, 83, 0.12)',
  grey9: 'rgba(0, 0, 0, 0.12)',
  grey10: 'rgba(0, 0, 0, 0.3)',
  blue: '#07abb8',
  blue2: '#133b5d',
  red: '#e21b51',
  silver: '#caced2',
};

const fontSize = {
  small: '9px',
  xSmall: '10px',
  base: '12px',
  medium: '14px',
  xMedium: '15px',
  large: '16px',
  xslarge: '17px',
  xLarge: '18px',
  xxLarge: '20px',
  xxxLarge: '26px',
};

const fontWeight = {
  xBase: 300,
  base: 400,
  medium: 500,
  bold: 600,
};

const borderRadius = {
  small: '2px',
  base: '4px',
  xMedium: '10px',
  medium: '12px',
  large: '20px',
  xLarge: '56px',
  circle: '50%',
};

const zIndex = {
  base: 1,
  under: 2,
  modal: 1001,
};

const background = {
  gradient: 'linear-gradient(168deg, #08b794 -6%, #069edd 113%)',
  gradient2: 'linear-gradient(108deg, #08b794 2%, #069edd 99%)',
  gradient3: 'linear-gradient(112deg, #009dff 8%, #307ad1 98%)',
  gradient4: 'linear-gradient(111deg, #f47111 3%, #ff0000 104%)',
  gradient5: 'linear-gradient(100deg, #08b794 -3%, #069edd 113%)',
  gradient6: 'linear-gradient(101deg, #08b794 4%, #069edd 99%)',
  gradient7: 'linear-gradient(138deg, #08b794 -6%, #069edd)',
  gradient8: 'linear-gradient(99deg, #08b794 3%, #069edd 100%)',
  gradient9: 'linear-gradient(108deg, #08b794 4%, #069edd 102%)',
  gradient10: 'linear-gradient(165deg, #34a680 13%, #005c89 96%)',
  gradient11: 'linear-gradient(108deg, #08b794 2%, #069edd 99%, #000000 99%)',
};

const theme = {
  color,
  fontSize,
  fontWeight,
  borderRadius,
  zIndex,
  background,
};

export default theme;
